var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side_nav"},[_c('sidebar-menu',{attrs:{"menu":_vm.menu,"collapsed":_vm.is_mobile_nav,"showOneChild":""},on:{"item-click":_vm.onItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }